import * as React from 'react';
import { withRouter } from "react-router";
import { NavLink } from "react-router-dom";
import './NavMenu.css';
import * as AuthStore from "../store/Auth";
import { logo } from '../img';
import { connect } from "react-redux";
import { ApplicationState } from '../store';
import { Navbar } from 'reactstrap';
import { Button, Avatar, Menu, Dropdown } from 'antd';
import { UploadOutlined, BarChartOutlined, HomeOutlined, FilterOutlined, CoffeeOutlined, FileSearchOutlined } from '@ant-design/icons/lib';

type AuthProps =
    AuthStore.AuthState // ... state we've requested from the Redux store
    & typeof AuthStore.actionCreators // ... plus action creators we've requested

class NavMenu extends React.Component<AuthProps>
{
    public state = { isOpen: false, logoutAction: false, current: '' };

    logout() {
        this.props.logOut();
    }

    handleClick(e: { key: any; }) {
        this.setState({
            current: e.key,
        });
    }

    render() {
        const user = this.props.appUser;

        const menu = (
            <Menu className='it-mn'>
                <Menu.Item key="1">
                    {user.firstName}
                </Menu.Item>
                {(user && user.role === "1") ? < Menu.Item key="2">
                    <NavLink exact to={'/users'} activeClassName="active">Users</NavLink>
                </Menu.Item> : null}
                {(user && user.role === "1") ? < Menu.Item key="3">
                    <NavLink exact to={'/dataMgt'} activeClassName="active">Manage Facility Data</NavLink>
                </Menu.Item> : null}
                <Menu.Item key="4">
                    <a style={{ cursor: 'pointer' }} onClick={() => this.logout()}>Sign out</a>
                </Menu.Item>
            </Menu>
        );

        const cit = (
            <Menu className='it-mn'>
                <Menu.Item key="13">
                    <NavLink exact to={'/citDashboard-q1-fy27'}>Q1 FY27</NavLink>
                </Menu.Item>
                <Menu.Item key="13">
                    <NavLink exact to={'/citDashboard-q4-fy26'}>Q4 FY26</NavLink>
                </Menu.Item>
                <Menu.Item key="12">
                    <NavLink exact to={'/citDashboard-q3-fy26'}>Q3 FY26</NavLink>
                </Menu.Item>
                <Menu.Item key="11">
                    <NavLink exact to={'/citDashboard-q2-fy26'}>Q2 FY26</NavLink>
                </Menu.Item>
                <Menu.Item key="10">
                    <NavLink exact to={'/citDashboard-q1-fy26'}>Q1 FY26</NavLink>
                </Menu.Item>
                <Menu.Item key="9">
                    <NavLink exact to={'/citDashboard-q4-fy25'}>Q4 FY25</NavLink>
                </Menu.Item>
                <Menu.Item key="8">
                    <NavLink exact to={'/citDashboard-q3-fy25'}>Q3 FY25</NavLink>
                </Menu.Item>
                <Menu.Item key="7">
                    <NavLink exact to={'/citDashboard-q2-fy25'}>Q2 FY25</NavLink>
                </Menu.Item>
                <Menu.Item key="6">
                    <NavLink exact to={'/citDashboard-q1-fy25'}>Q1 FY25</NavLink>
                </Menu.Item>
                <Menu.Item key="5">
                    <NavLink exact to={'/citDashboard-q4-fy24'}>Q4 FY24</NavLink>
                </Menu.Item>
                <Menu.Item key="4">
                    <NavLink exact to={'/citDashboard-q3-fy24'}>Q3 FY24</NavLink>
                </Menu.Item>
                <Menu.Item key="3">
                    <NavLink exact to={'/citDashboard-q2-fy24'}>Q2 FY24</NavLink>
                </Menu.Item>
                <Menu.Item key="2">
                    <NavLink exact to={'/citDashboard-q1-fy24'}>Q1 FY24</NavLink>
                </Menu.Item>
                <Menu.Item key="1">
                    <NavLink exact to={'/citDashboard-q4-fy23'}>Q4 FY23</NavLink>
                </Menu.Item>
            </Menu>
        );

        const uploads = (
            <Menu className='it-mn'>
                {(user && user.role && user.role !== "2") ? <Menu.Item key="1">
                    <NavLink exact to={'/upload'}>New Upload</NavLink>
                </Menu.Item> : null}
                <Menu.Item key="2">
                    <NavLink exact to={'/uploads'}>Previous Uploads</NavLink>
                </Menu.Item>
            </Menu>
        );
        const audit = (
            <Menu className='it-mn'>
                <Menu.Item key="1">
                    <NavLink exact to={'/onboardingAudit'}>On-boarding Audit</NavLink>
                </Menu.Item>
                <Menu.Item key="2">
                    <NavLink exact to={'/patient'}>Deep-dive (Patient level)</NavLink>
                </Menu.Item>
                <Menu.Item key="3">
                    <NavLink exact to={'/edqa'}>E-DQA (Facility)</NavLink>
                </Menu.Item>
                <Menu.Item key="4">
                    <NavLink exact to={'/manifests'}>LIMS-EMR</NavLink>
                </Menu.Item>
            </Menu>
        );

        const tracking = (
            <Menu className='it-mn'>
                <Menu.Item key="1">
                    <NavLink exact to={'/refill'}>Due for ARV Refill</NavLink>
                </Menu.Item>
                <Menu.Item key="2">
                    <NavLink exact to={'/dueforPvls'}>Due For PVLS</NavLink>
                </Menu.Item>
                <Menu.Item key="3">
                    <NavLink exact to={'/missedAppointments'}>Missed Appointments</NavLink>
                </Menu.Item>
                <Menu.Item key="4">
                    <NavLink exact to={'/tracking'}>Tracking & Termination</NavLink>
                </Menu.Item>
            </Menu>
        );

        const jolly = (
            <Menu className='it-mn'>
                <Menu.Item key="reasons">
                    <NavLink exact to={'/reasons'}>Counselling Reasons</NavLink>
                </Menu.Item>
                <Menu.Item key="providers">
                    <NavLink exact to={'/providers'}>Service Providers</NavLink>
                </Menu.Item>
                <Menu.Item key="dispatch">
                    <NavLink exact to={'/dispatchers'}>Dispatch Riders</NavLink>
                </Menu.Item>
                <Menu.Item key="counselling">
                    <NavLink exact to={'/counsellingRequests'}>Counselling Requests</NavLink>
                </Menu.Item>
                <Menu.Item key="refill">
                    <NavLink exact to={'/artSchedules'}>ART Refill Schedules</NavLink>
                </Menu.Item>
                <Menu.Item key="vl">
                    <NavLink exact to={'/vlSchedules'}>Viral Load Bleeding Schedules</NavLink>
                </Menu.Item>
                <Menu.Item key="archives">
                    <NavLink exact to={'/contactDataArchive'}>Contact Data Archives</NavLink>
                </Menu.Item>
                <Menu.Item key="messages">
                    <NavLink exact to={'/messaging'}>In-App Chats</NavLink>
                </Menu.Item>
                <Menu.Item key="reactions">
                    <NavLink exact to={'#'}>Adverse Drug Reactions</NavLink>
                </Menu.Item>
                <Menu.Item key="pharmacies">
                    <NavLink exact to={'#'}>Community Pharmacies</NavLink>
                </Menu.Item>
                <Menu.Item key="uu">
                    <NavLink exact to={'#'}>U = U</NavLink>
                </Menu.Item>
            </Menu>
        );

        const perf = (
            <Menu className='it-mn'>
                <Menu.Item key="1">
                    <NavLink exact to={'/stateQuery'}>States</NavLink>
                </Menu.Item>
                <Menu.Item key="2">
                    <NavLink exact to={'/siteQuery'}>Sites</NavLink>
                </Menu.Item>
            </Menu>
        );

        return <header>
            <Navbar className="navbar-expand-sm navbar-toggleable-sm border-bottom box-shadow mb-3 c-header" light>
                <div className="navbar navbar-default">
                    <div className="container-fluid">
                        <div className="lgg">
                            <NavLink exact to={'/home'} className="navbar-brand">
                                <img className="logo2" src={logo} alt="" />
                                <span className="brand-label">CDR</span>
                            </NavLink>
                        </div>
                        <Menu className="ant-mn c-header" onClick={(e) => this.handleClick(e)} selectedKeys={[this.state.current]} mode="horizontal">
                            <Menu.Item key="cit" className="top-menu-item">
                                <Dropdown overlay={cit}>
                                    <Button>
                                        <BarChartOutlined />
                                        CIT Dashboard
                                    </Button>
                                </Dropdown>
                            </Menu.Item>

                            <Menu.Item key="mer" className="top-menu-item">
                                <BarChartOutlined />
                                <span><NavLink exact to={'/mer'}>MER</NavLink></span>
                            </Menu.Item>
                            <Menu.Item key="import" className="top-menu-item">
                                <Dropdown overlay={uploads}>
                                    <Button>
                                        <UploadOutlined />
                                        Data Upload
                                    </Button>
                                </Dropdown>
                            </Menu.Item>
                            <Menu.Item key="auditing" className="top-menu-item">
                                <Dropdown overlay={audit}>
                                    <Button>
                                        <FilterOutlined />
                                        Data Quality
                                    </Button>
                                </Dropdown>
                            </Menu.Item>
                            <Menu.Item key="tracking" className="top-menu-item">
                                <Dropdown overlay={tracking}>
                                    <Button>
                                        <FileSearchOutlined />
                                        Patient Tracking
                                    </Button>
                                </Dropdown>
                            </Menu.Item>
                            {(user && (user.role === "1" || user.role === "4" || user.role === "5" || user.role === "6")) ? <Menu.Item key="jolly" className="top-menu-item">
                                <Dropdown overlay={jolly}>
                                    <Button>
                                        <CoffeeOutlined />
                                        Jolly95
                                    </Button>
                                </Dropdown>
                            </Menu.Item> : null}
                            <Menu.Item key="sites" className="top-menu-item">
                                <HomeOutlined />
                                <span> <NavLink exact to={'/sites'}>Facilities</NavLink></span>
                            </Menu.Item>
                            <Menu.Item key="auth" className="top-menu-item">
                                {(user !== undefined && user !== null && user.isAuthenticated) ?
                                    <Dropdown overlay={menu} className="avtr">
                                        <Button className="profileStyle">
                                            <Avatar className="userIcon" style={{ backgroundColor: '#87d068' }} /> {/*icon={<UserOutlined />*/}
                                        </Button>
                                    </Dropdown>
                                    :
                                    <NavLink className="glyphicon glyphicon-log-in" role="button" exact to={'/welcome'} activeClassName="active"></NavLink>
                                }
                            </Menu.Item>
                        </Menu>
                    </div>
                </div>
            </Navbar>
        </header>;
    }

}

var component = connect(
    (state: ApplicationState) => state.auth, // Selects which state properties are merged into the component's props
    AuthStore.actionCreators // Selects which action creators are merged into the component's props
)(NavMenu as any);

export default withRouter(component);